import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

const zhCN = {
  brand: { name: 'licensor', panel: 'licensor', copyright: '版权所有 © 2021-2026 Licensor', crumb: '管理后台' },
  auth: {
    tagline: '管理后台', taglineSub: '仅限内部管理员账号登录，所有操作写入审计日志。',
    login: '登录', email: '邮箱', password: '密码', totp: '两步验证码（未开启可留空）', submit: '登录',
    footerHint: '账号由所有者开通，如需新增管理员请联系系统所有者。',
  },
  nav: {
    dashboard: '概览', products: '产品管理', customers: '客户管理', coupons: '优惠券', orders: '订单管理', licenses: '授权管理',
    trials: '试用申请', audit: '审计日志', admins: '用户管理', signOut: '退出登录',
  },
  dashboard: {
    title: 'Licensor 后台概览', refresh: '刷新',
    orders: '订单总数', licenses: '授权总数', revenue: '已收款',
    recentOrders: '最近订单', legend: '订单状态：1 已创建 · 2 待支付 · 3 已支付 · 4 已履约 · 5 支付失败 · 6 已超时关闭 · 7 已退款',
  },
  products: {
    title: 'Licensor 产品', create: '新建产品', edit: '编辑产品',
    colProduct: '产品', colStatus: '状态', colEditions: '版本与价格', colTrial: '试用', colAction: '操作',
    legend: '产品状态：1 草稿 · 2 上架 · 3 已归档。试用列展示各产品是否开启试用（trial_enabled / trial_days，默认 7 天）；前台申请经后台审批后自动发放。',
    trialOn: '试用 {{days}} 天', trialOff: '未开启',
    archive: '归档', archived: '已归档',
    publish: '上架', unpublish: '下架', restore: '恢复',
    publishDone: '产品已上架', unpublishDone: '产品已下架', restoreDone: '产品已恢复为草稿',
    status: { 1: '草稿', 2: '上架', 3: '已归档' },
    m: {
      basic: '基本信息', code: '产品编码 *', name: '产品名称 *', desc: '产品描述', icon: '图标 URL',
      editions: '版本与价格', edName: '版本名称', edCode: '版本编码', price: '价格', duration: '时长',
      month: '月', year: '年', addEdition: '添加版本', durationHint: '时长按自然月 / 年换算写入 duration_days：月 = 30 天，年 = 365 天',
      trial: '试用授权', trialToggle: '允许试用申请', trialToggleSub: '开启后该产品在前台展示「申请试用」入口',
      trialPrice: '试用价格', trialPriceHint: '海外版试用需购买；留空按默认价（$1）计。',
      trialDays: '试用时长（天）', trialMode: '审批方式', trialModeValue: '需后台审批',
      trialHint: '开启后用户可在前台提交试用申请；国内版为 0 元审批发放，海外版为付费直接下单，默认 7 天。',
      remove: '移除', removeEdition: '删除该版本（保存后生效）',
      editionIncomplete: '第 {{n}} 个版本信息不完整：版本名称和版本编码都要填写',
      editionCodeDup: '版本编码重复：{{code}}',
      priceInvalid: '价格需大于 0，最多两位小数',
      priceRequired: '已有版本的价格不能清空；如需移除请删除该版本行',
      trialDaysInvalid: '试用时长需为 1–365 的整数',
      capabilities: '能力', noCapabilities: '暂无可用能力', capabilitiesNew: '新版本保存后可再挂载能力',
    },
  },
  coupons: {
    title: '优惠券', export: '导出券码', generate: '生成优惠券',
    colCode: '券码', colKind: '类型', colValue: '优惠力度', colScope: '适用范围', colValid: '有效期', colStatus: '状态', colAction: '操作',
    searchPh: '搜索券码', allTypes: '全部类型', allStatus: '全部状态', reset: '重置',
    kindPercent: '折扣券', kindAmount: '优惠券',
    statusUnused: '未使用', statusUsed: '已使用', statusDisabled: '已停用', statusExpired: '已过期',
    summary: '共 {{total}} 张 · 未使用 {{unused}} · 已使用 {{used}} · 已停用 {{disabled}} · 已过期 {{expired}}',
    copy: '复制券码', copied: '券码已复制', disable: '停用', enable: '启用',
    scopeAll: '全部产品 · 全部版本', used: '已使用',
    m: {
      title: '生成优惠券', kind: '券类型', percent: '折扣券', amount: '优惠券',
      percentLabel: '折扣力度', percentUnit: '折', amountLabel: '优惠金额', minSpend: '使用门槛（留空无门槛）',
      scope: '适用范围', product: '适用产品', edition: '适用版本', allProducts: '全部产品', allEditions: '全部版本',
      valid: '有效期与券码', from: '开始日期', to: '结束日期', prefix: '券码前缀',
      hint: '券码按前缀自动生成（{{prefix}}-‹4 位›-‹4 位›），每次生成一张券；生成后可在「优惠券」列表中复制或停用。',
      discountHint: '折扣力度按折计算（8.5 折 = 原价 × 0.85）；门槛留空表示无门槛。',
      preview: '券预览', previewOriginal: '原价', previewPayable: '实付',
      cancel: '取消', submit: '生成优惠券',
      resultTitle: '优惠券已生成', resultBanner: '优惠券已生成，券码立即可用',
      resultCode: '券码', resultKind: '券类型', resultScope: '适用范围', resultValid: '有效期', resultStatus: '使用状态',
      resultUnused: '未使用', resultViewList: '查看列表', resultCopy: '复制券码',
      resultHint: '券码同时出现在「优惠券」列表中，可随时复制或停用；未使用的券码不会被核销，停用后立即失效。',
      percentValue: '{{v}} 折', amountValue: '立减 {{v}}', amountThreshold: '满 {{m}} 减 {{v}}',
      scopeValue: '{{p}} · {{e}}', confirmDisable: '确认停用该券码？停用后立即失效。',
    },
  },
  orders: {
    title: 'Licensor 订单', export: '导出 CSV',
    colCode: '订单号', colProduct: '产品', colCustomer: '客户', colAmount: '金额', colStatus: '状态', colCreated: '创建时间', colAction: '操作',
    searchPh: '订单号 / 邮箱', search: '搜索',
    refund: '退款', reconcile: '对账', legend: '仅状态 3 / 4（已支付 / 已履约）可退款；退款为敏感操作，需 TOTP 二次验证并写入审计。',
    summary: '共 {{total}} 笔订单', paidAt: '支付', discount: '优惠',
    status: { 1: '已创建', 2: '待支付', 3: '已支付', 4: '已履约', 5: '支付失败', 6: '已超时关闭', 7: '已退款' },
    refundConfirm: '确认退款？该操作不可撤销，需要 TOTP 二次验证。',
    exported: '已导出当前页',
  },
  licenses: {
    title: 'Licensor 授权', export: '导出 CSV',
    colCode: '授权码', colEdition: '产品 / 版本', colState: '状态', colMachine: '绑定设备', colLease: '租约', colExpired: '到期时间', colAction: '操作',
    legend: '授权状态：1 待激活 · 2 已激活 · 3 已绑定 · 4 已暂停 · 5 已吊销 · 6 已过期。发放后为待激活，首次绑定设备时激活并按授权时长重算到期时间；Machine 为空时显示「未绑定」；Lease 为租约版本号。',
    manage: '管理', suspend: '暂停', resume: '恢复', revoke: '吊销', forceUnbind: '强制解绑',
    state: { 1: '待激活', 2: '已激活', 3: '已绑定', 4: '已暂停', 5: '已吊销', 6: '已过期' },
    reason: '操作原因', noMachine: '未绑定',
    revealCode: '查看明文', hideCode: '隐藏', copyCode: '复制授权码',
    colActivated: '激活时间', colDuration: '授权时长',
    durationDays: '{{v}} 天', perpetual: '永久',
  },
  licenseDetail: {
    title: '授权详情', back: '返回授权列表', info: '授权信息', ops: '授权操作',
    perform: '执行', sensitiveHint: '以下为敏感操作，执行需 TOTP 二次验证并写入审计日志。',
  },
  audit: {
    title: 'Licensor 审计日志', export: '导出 CSV',
    colTime: '时间', colActor: '操作者', colAction: '动作', colTarget: '详情', colIP: 'IP',
    legend: '共 {{n}} 条 · 仅追加写入，不可修改或删除',
    targets: { admin: '运营账号', customer: '客户', license: '授权', order: '订单', product: '产品', edition: '版本', coupon: '优惠券', price: '价格', capability: '能力', trial: '试用申请' },
    meta: {
      status: '状态', code: '编码', editions: '版本数', deleted_editions: '删除版本',
      email: '邮箱', product_id: '产品 ID', edition_id: '版本 ID', license_id: '授权 ID', payment_id: '支付单 ID',
      amount: '金额', currency: '币种', duration_days: '时长', kind: '券类型', reason: '原因', days: '试用天数',
      dayValue: '{{v}} 天',
    },
    actions: {
      admin_login: '登录后台',
      admin_totp_confirm: '开启两步验证',
      admin_totp_disable: '解除两步验证',
      admin_sensitive_reauth: '敏感操作二次验证',
      admin_customer_enable: '启用客户账号',
      admin_customer_disable: '禁用客户账号',
      admin_operator_create: '新建运营账号',
      admin_operator_enable: '启用运营账号',
      admin_operator_disable: '禁用运营账号',
      admin_operator_roles: '调整运营账号角色',
      admin_operator_password: '重置运营账号密码',
      admin_operator_delete: '删除运营账号',
      catalog_product_create: '新建产品',
      catalog_product_update: '更新产品',
      catalog_product_archive: '归档产品',
      catalog_product_publish: '上架产品',
      catalog_product_unpublish: '下架产品',
      catalog_product_restore: '恢复产品',
      catalog_edition_create: '新建版本',
      catalog_edition_update: '更新版本',
      catalog_capability_create: '新建能力',
      catalog_capability_attach: '关联能力',
      catalog_capability_detach: '解除能力关联',
      catalog_price_create: '新建价格',
      catalog_price_update: '更新价格',
      catalog_price_deactivate: '停用价格',
      coupon_generate: '生成优惠券',
      coupon_disable: '停用优惠券',
      coupon_enable: '启用优惠券',
      ops_order_refund: '订单退款',
      ops_order_reconcile: '订单对账',
      ops_license_suspend: '暂停授权',
      ops_license_resume: '恢复授权',
      ops_license_revoke: '吊销授权',
      ops_license_force_unbind: '强制解绑设备',
      trial_request_approve: '通过试用申请',
      trial_request_reject: '驳回试用申请',
    },
  },
  customers: {
    title: '终端客户', sub: 'Licensor 终端客户（buyers）', searchPh: '邮箱 / 姓名', search: '搜索',
    colEmail: '邮箱', colName: '姓名', colVerified: '邮箱验证', colStatus: '状态', colCreated: '注册时间',
    verified: '已验证', unverified: '未验证', detail: '详情', detailTitle: '客户详情',
    source: '来源', marketing: '营销订阅', failedLogin: '连续失败次数', lastLogin: '最近登录', updated: '更新时间',
    yes: '是', no: '否', summary: '共 {{total}} 位客户', prev: '上一页', next: '下一页', pageOf: '第 {{page}} / {{pages}} 页',
    statusActive: '正常', statusDisabled: '已禁用', disable: '禁用', enable: '启用',
  },
  admins: {
    title: '用户管理与安全', profile: '个人资料', totp: '两步验证（TOTP）',
    email: '邮箱', name: '姓名', roles: '角色', permissions: '权限', status: '状态',
    enabled: '已开启', disabled: '未开启', enroll: '开始绑定', disable: '解除绑定',
    uri: '请使用验证器 App 扫描或粘贴以下 URI：', code: '输入 6 位验证码确认', confirm: '确认绑定',
    enrolled: 'TOTP 已开启', done: '绑定成功', disabledOk: '已解除绑定',
    operators: '运营账号', operatorLegend: '运营账号的启用状态与角色在此维护；不能禁用或删除当前登录账号。',
    create: '新建运营账号', editRoles: '调整角色', password: '初始密码',
    passwordHint: '密码至少 12 位；初始密码可在列表中重置。',
    resetPassword: '重置密码', newPassword: '新密码',
    emailInvalid: '请输入有效邮箱', passwordShort: '密码至少 12 位',
    delete: '删除', deleteConfirm: '确认删除 {{email}} 的运营账号？删除后立即失效且不可恢复。',
    accActive: '正常', accDisabled: '已禁用', accEnable: '启用', accDisable: '禁用',
  },
  trials: {
    title: '试用申请审批', sub: '前台提交的 0 元试用申请在此审批，通过后立即写入试用授权', export: '导出',
    statPending: '待审批', statApprovedToday: '今日已通过', statRejectedWeek: '本周驳回',
    colId: '申请编号', colApplicant: '申请人', colProduct: '产品 · 版本', colNote: '申请说明', colStatus: '状态', colCreated: '提交时间', colAction: '操作',
    review: '审批',
    status: { 1: '待审批', 2: '已通过', 3: '已驳回' },
    legend: '审批通过发放待激活授权；客户首次绑定设备时激活，试用到期 = 激活日 + 批准天数（默认 7 天）。驳回需填写原因。',
    m: {
      title: '审批试用申请', id: '申请编号', applicant: '申请人', product: '产品 · 版本', created: '提交时间',
      days: '批准试用时长（天）', daysUnit: '天', daysHint: '默认取产品配置的试用时长（{{days}} 天），可针对本次申请单独调整。',
      note: '审批备注', notePh: '填写审批说明；驳回时必填',
      notice: '通过后立即创建待激活的试用授权；客户首次绑定设备时激活，到期日 = 激活日 + 批准天数，并通知用户。',
      approve: '通过', reject: '驳回', reasonRequired: '驳回时必须填写原因',
    },
  },
  common: {
    cancel: '取消', save: '保存', confirm: '确认', close: '关闭', copy: '复制', copied: '已复制',
    loading: '加载中…', empty: '暂无数据', loadFailed: '加载失败', retry: '重试',
    total: '共 {{n}} 条', all: '全部', actions: '操作', success: '操作成功',
    totpTitle: '敏感操作验证', totpLabel: 'TOTP 验证码', totpPh: '6 位数字', totpConfirm: '验证并继续',
    totpInvalid: 'TOTP 验证失败', needReason: '请填写操作原因', exported: '已导出当前页',
  },
}

const enUS = {
  brand: { name: 'licensor', panel: 'licensor', copyright: 'Copyright © 2021-2026 Licensor', crumb: 'Admin Panel' },
  auth: {
    tagline: 'Admin Panel', taglineSub: 'Internal admins only. Every action is audit-logged.',
    login: 'Sign in', email: 'Email', password: 'Password', totp: '2FA code (leave empty if not enabled)', submit: 'Sign in',
    footerHint: 'Accounts are provisioned by the owner; contact the system owner for new admins.',
  },
  nav: {
    dashboard: 'Overview', products: 'Product Management', customers: 'Customers', coupons: 'Coupons', orders: 'Order Management', licenses: 'License Management',
    trials: 'Trials', audit: 'Audit Log', admins: 'User Management', signOut: 'Sign out',
  },
  dashboard: {
    title: 'Licensor Overview', refresh: 'Refresh',
    orders: 'Orders', licenses: 'Licenses', revenue: 'Collected',
    recentOrders: 'Recent orders', legend: 'Order status: 1 created · 2 awaiting payment · 3 paid · 4 fulfilled · 5 failed · 6 expired · 7 refunded',
  },
  products: {
    title: 'Licensor Products', create: 'New product', edit: 'Edit product',
    colProduct: 'Product', colStatus: 'Status', colEditions: 'Editions & prices', colTrial: 'Trial', colAction: 'Actions',
    legend: 'Product status: 1 draft · 2 active · 3 archived. The trial column shows whether trials are enabled (trial_enabled / trial_days, default 7); portal requests are approved by an operator.',
    trialOn: '{{days}}-day trial', trialOff: 'Off',
    archive: 'Archive', archived: 'Archived',
    publish: 'Publish', unpublish: 'Unpublish', restore: 'Restore',
    publishDone: 'Product published', unpublishDone: 'Product unpublished', restoreDone: 'Product restored to draft',
    status: { 1: 'Draft', 2: 'Active', 3: 'Archived' },
    m: {
      basic: 'Basics', code: 'Code *', name: 'Name *', desc: 'Description', icon: 'Icon URL',
      editions: 'Editions & prices', edName: 'Edition name', edCode: 'Edition code', price: 'Price', duration: 'Duration',
      month: 'month', year: 'year', addEdition: 'Add edition', durationHint: 'Durations map to duration_days: month = 30 days, year = 365 days',
      trial: 'Trial', trialToggle: 'Allow trial requests', trialToggleSub: 'Shows the trial entry on the portal',
      trialPrice: 'Trial price', trialPriceHint: 'Overseas trials are purchased; empty uses the default ($1).',
      trialDays: 'Trial length (days)', trialMode: 'Approval', trialModeValue: 'Panel approval required',
      trialHint: 'Users can request a trial: domestic deployments approve it for free, overseas deployments sell it through checkout. Default 7 days.',
          remove: 'Remove', removeEdition: 'Delete this edition (applied on save)',
          editionIncomplete: 'Edition #{{n}} is incomplete: fill in both name and code',
          editionCodeDup: 'Duplicate edition code: {{code}}',
          priceInvalid: 'Price must be greater than 0 with up to 2 decimals',
          priceRequired: 'Existing editions must keep a price; delete the edition row to remove it',
          trialDaysInvalid: 'Trial length must be a whole number between 1 and 365',
          capabilities: 'Capabilities', noCapabilities: 'No capabilities defined', capabilitiesNew: 'Save the edition first, then attach capabilities',
    },
  },
  coupons: {
    title: 'Coupons', export: 'Export codes', generate: 'Generate coupon',
    colCode: 'Code', colKind: 'Type', colValue: 'Value', colScope: 'Scope', colValid: 'Validity', colStatus: 'Status', colAction: 'Actions',
    searchPh: 'Search code', allTypes: 'All types', allStatus: 'All statuses', reset: 'Reset',
    kindPercent: 'Discount', kindAmount: 'Voucher',
    statusUnused: 'Unused', statusUsed: 'Used', statusDisabled: 'Disabled', statusExpired: 'Expired',
    summary: '{{total}} total · {{unused}} unused · {{used}} used · {{disabled}} disabled · {{expired}} expired',
    copy: 'Copy code', copied: 'Code copied', disable: 'Disable', enable: 'Enable',
    scopeAll: 'All products · All editions', used: 'Used',
    m: {
      title: 'Generate coupon', kind: 'Type', percent: 'Discount', amount: 'Voucher',
      percentLabel: 'Discount rate', percentUnit: '% off', amountLabel: 'Amount off', minSpend: 'Min spend (empty = none)',
      scope: 'Scope', product: 'Product', edition: 'Edition', allProducts: 'All products', allEditions: 'All editions',
      valid: 'Validity & code', from: 'Start date', to: 'End date', prefix: 'Code prefix',
      hint: 'The code is generated from the prefix ({{prefix}}-‹4›-‹4›), one coupon per call; copy or disable it in the coupon list afterwards.',
      discountHint: 'A discount coupon takes a percentage off (15% off = price × 0.85); an amount coupon takes a fixed amount off. Empty min spend = no threshold.',
      preview: 'Preview', previewOriginal: 'Original', previewPayable: 'Payable',
      cancel: 'Cancel', submit: 'Generate coupon',
      resultTitle: 'Coupon generated', resultBanner: 'Coupon generated, the code is usable immediately',
      resultCode: 'Code', resultKind: 'Type', resultScope: 'Scope', resultValid: 'Validity', resultStatus: 'Status',
      resultUnused: 'Unused', resultViewList: 'View list', resultCopy: 'Copy code',
      resultHint: 'The code also appears in the coupon list; unused codes are never redeemed, disabled codes fail immediately.',
      percentValue: '{{n}}% off', amountValue: '{{v}} off', amountThreshold: '{{m}} minus {{v}}',
      scopeValue: '{{p}} · {{e}}', confirmDisable: 'Disable this code? It fails immediately.',
    },
  },
  orders: {
    title: 'Licensor Orders', export: 'Export CSV',
    colCode: 'Order', colProduct: 'Product', colCustomer: 'Customer', colAmount: 'Amount', colStatus: 'Status', colCreated: 'Created', colAction: 'Actions',
    searchPh: 'Order code / email', search: 'Search',
    refund: 'Refund', reconcile: 'Reconcile', legend: 'Only paid (3) / fulfilled (4) orders can be refunded; refunds are sensitive and require TOTP re-auth.',
    summary: '{{total}} orders', paidAt: 'Paid', discount: 'Discount',
    status: { 1: 'Created', 2: 'Awaiting payment', 3: 'Paid', 4: 'Fulfilled', 5: 'Failed', 6: 'Expired', 7: 'Refunded' },
    refundConfirm: 'Refund this order? This cannot be undone and requires TOTP.',
    exported: 'Current page exported',
  },
  licenses: {
    title: 'Licensor Licenses', export: 'Export CSV',
    colCode: 'License', colEdition: 'Product / Edition', colState: 'State', colMachine: 'Machine', colLease: 'Lease', colExpired: 'Expires', colAction: 'Actions',
    legend: 'License status: 1 pending · 2 active · 3 bound · 4 suspended · 5 revoked · 6 expired. Licenses are issued pending; the clock starts and expiry is recomputed at first machine binding. Machine shows "Unbound" when empty; Lease is the lease version.',
    manage: 'Manage', suspend: 'Suspend', resume: 'Resume', revoke: 'Revoke', forceUnbind: 'Force unbind',
    state: { 1: 'Pending', 2: 'Active', 3: 'Bound', 4: 'Suspended', 5: 'Revoked', 6: 'Expired' },
    reason: 'Reason', noMachine: 'Unbound',
    revealCode: 'Reveal code', hideCode: 'Hide', copyCode: 'Copy code',
    colActivated: 'Activated', colDuration: 'Duration',
    durationDays: '{{v}} days', perpetual: 'Perpetual',
  },
  licenseDetail: {
    title: 'License detail', back: 'Back to licenses', info: 'License', ops: 'Operations',
    perform: 'Perform', sensitiveHint: 'These are sensitive operations; TOTP re-auth is required and every call is audit-logged.',
  },
  audit: {
    title: 'Licensor Audit Log', export: 'Export CSV',
    colTime: 'Time', colActor: 'Actor', colAction: 'Action', colTarget: 'Detail', colIP: 'IP',
    legend: '{{n}} entries · append-only, cannot be modified or deleted',
    targets: { admin: 'Operator', customer: 'Customer', license: 'License', order: 'Order', product: 'Product', edition: 'Edition', coupon: 'Coupon', price: 'Price', capability: 'Capability', trial: 'Trial request' },
    meta: {
      status: 'Status', code: 'Code', editions: 'Editions', deleted_editions: 'Editions removed',
      email: 'Email', product_id: 'Product ID', edition_id: 'Edition ID', license_id: 'License ID', payment_id: 'Payment ID',
      amount: 'Amount', currency: 'Currency', duration_days: 'Duration', kind: 'Type', reason: 'Reason', days: 'Trial days',
      dayValue: '{{v}} days',
    },
    actions: {
      admin_login: 'Signed in',
      admin_totp_confirm: 'TOTP enabled',
      admin_totp_disable: 'TOTP disabled',
      admin_sensitive_reauth: 'Sensitive re-auth',
      admin_customer_enable: 'Enabled customer',
      admin_customer_disable: 'Disabled customer',
      admin_operator_create: 'Created operator',
      admin_operator_enable: 'Enabled operator',
      admin_operator_disable: 'Disabled operator',
      admin_operator_roles: 'Changed operator roles',
      admin_operator_password: 'Reset operator password',
      admin_operator_delete: 'Deleted operator',
      catalog_product_create: 'Created product',
      catalog_product_update: 'Updated product',
      catalog_product_archive: 'Archived product',
      catalog_product_publish: 'Published product',
      catalog_product_unpublish: 'Unpublished product',
      catalog_product_restore: 'Restored product',
      catalog_edition_create: 'Created edition',
      catalog_edition_update: 'Updated edition',
      catalog_capability_create: 'Created capability',
      catalog_capability_attach: 'Attached capability',
      catalog_capability_detach: 'Detached capability',
      catalog_price_create: 'Created price',
      catalog_price_update: 'Updated price',
      catalog_price_deactivate: 'Deactivated price',
      coupon_generate: 'Generated coupon',
      coupon_disable: 'Disabled coupon',
      coupon_enable: 'Enabled coupon',
      ops_order_refund: 'Refunded order',
      ops_order_reconcile: 'Reconciled order',
      ops_license_suspend: 'Suspended license',
      ops_license_resume: 'Resumed license',
      ops_license_revoke: 'Revoked license',
      ops_license_force_unbind: 'Force-unbound machine',
      trial_request_approve: 'Approved trial request',
      trial_request_reject: 'Rejected trial request',
    },
  },
  customers: {
    title: 'Customers', sub: 'Licensor end customers (buyers)', searchPh: 'Email / name', search: 'Search',
    colEmail: 'Email', colName: 'Name', colVerified: 'Email verified', colStatus: 'Status', colCreated: 'Signed up',
    verified: 'Verified', unverified: 'Unverified', detail: 'Detail', detailTitle: 'Customer detail',
    source: 'Source', marketing: 'Marketing opt-in', failedLogin: 'Failed logins', lastLogin: 'Last login', updated: 'Updated',
    yes: 'Yes', no: 'No', summary: '{{total}} customers', prev: 'Previous', next: 'Next', pageOf: 'Page {{page}} / {{pages}}',
    statusActive: 'Active', statusDisabled: 'Disabled', disable: 'Disable', enable: 'Enable',
  },
  admins: {
    title: 'Users & Security', profile: 'Profile', totp: 'Two-factor (TOTP)',
    email: 'Email', name: 'Name', roles: 'Roles', permissions: 'Permissions', status: 'Status',
    enabled: 'Enabled', disabled: 'Disabled', enroll: 'Enroll', disable: 'Disable',
    uri: 'Scan or paste this URI into your authenticator app:', code: 'Enter the 6-digit code to confirm', confirm: 'Confirm',
    enrolled: 'TOTP enabled', done: 'Enrolled', disabledOk: 'TOTP disabled',
    operators: 'Operators', operatorLegend: 'Operator status and roles are managed here; the account you are signed in with cannot be disabled or deleted.',
    create: 'New operator', editRoles: 'Edit roles', password: 'Initial password',
    passwordHint: 'At least 12 characters; the initial password can be reset from the list.',
    resetPassword: 'Reset password', newPassword: 'New password',
    emailInvalid: 'Enter a valid email', passwordShort: 'Password must be at least 12 characters',
    delete: 'Delete', deleteConfirm: 'Delete the operator account for {{email}}? It stops working immediately and cannot be restored.',
    accActive: 'Active', accDisabled: 'Disabled', accEnable: 'Enable', accDisable: 'Disable',
  },
  trials: {
    title: 'Trial approvals', sub: 'Portal trial requests are approved here; approval issues the trial license immediately', export: 'Export',
    statPending: 'Pending', statApprovedToday: 'Approved today', statRejectedWeek: 'Rejected this week',
    colId: 'Request', colApplicant: 'Applicant', colProduct: 'Product · Edition', colNote: 'Note', colStatus: 'Status', colCreated: 'Submitted', colAction: 'Actions',
    review: 'Review',
    status: { 1: 'Pending', 2: 'Approved', 3: 'Rejected' },
    legend: 'Approval issues the license as pending; the trial clock starts at first machine binding: expiry = activation date + granted days (default 7). Rejection requires a reason.',
    m: {
      title: 'Review trial request', id: 'Request', applicant: 'Applicant', product: 'Product · Edition', created: 'Submitted',
      days: 'Granted trial length (days)', daysUnit: 'days', daysHint: 'Defaults to the product trial length ({{days}} days); adjust per request.',
      note: 'Review note', notePh: 'Review note; required when rejecting',
      notice: 'On approval a pending trial license is created immediately; the clock starts at first machine binding: expiry = activation date + granted days. The user is notified.',
      approve: 'Approve', reject: 'Reject', reasonRequired: 'A reason is required to reject',
    },
  },
  common: {
    cancel: 'Cancel', save: 'Save', confirm: 'Confirm', close: 'Close', copy: 'Copy', copied: 'Copied',
    loading: 'Loading…', empty: 'No data', loadFailed: 'Failed to load', retry: 'Retry',
    total: '{{n}} items', all: 'All', actions: 'Actions', success: 'Done',
    totpTitle: 'Sensitive action', totpLabel: 'TOTP code', totpPh: '6 digits', totpConfirm: 'Verify & continue',
    totpInvalid: 'TOTP verification failed', needReason: 'A reason is required', exported: 'Current page exported',
  },
}

export const i18n = i18next.createInstance()

// 部署区域决定默认语言：国内版 zh-CN、海外版 en-US（构建期 VITE_DEFAULT_LOCALE
// 注入，默认 zh-CN）；localStorage 已选语言优先。
const defaultLocale = import.meta.env.VITE_DEFAULT_LOCALE || 'zh-CN'

void i18n.use(initReactI18next).init({
  resources: {
    'zh-CN': { translation: zhCN },
    'en-US': { translation: enUS },
  },
  lng: localStorage.getItem('licensor-locale') || defaultLocale,
  fallbackLng: 'zh-CN',
  interpolation: { escapeValue: false },
  returnNull: false,
})
